export const micRecording = {
  title: {
    "en": "Recording in-progress",
    "hi": "रिकॉर्डिंग जारी है",
    "or": "ରେକର୍ଡିଂ ଚାଲିଛି",
    "mr": "रेकॉर्डिंग सुरू आहे"
  },
  subtitle: {
    "en": "Click stop when done",
    "hi": "रिकॉर्डिंग बंद करने के लिए “बंद करें” दबाएँ।",
    "or": "ରେକର୍ଡିଂ ହୋଇଗଲେ 'ବନ୍ଦ କରନ୍ତୁ' କ୍ଲିକ୍ କରନ୍ତୁ",
    "mr": "पूर्ण झाल्यावर 'थांबा' वर क्लिक करा"
  },
  stop: {
    "en": "Question Done, Next",
    "hi": "सवाल ख़त्म, आगे बढ़ें",
    "or": "ପ୍ରଶ୍ନ ଶେଷ, ଆଗକୁ",
    "mr": "प्रश्न पूर्ण झाला, पुढे जा"
  }
};

export const recordedAudio = {
  title: {
    "en": "Verify your question below",
    "hi": "अपना सवाल जांच लें।",
    "or": "ତଳେ ଦିଆଯାଇଥିବା ଆପଣଙ୍କ ପ୍ରଶ୍ନ ଯାଞ୍ଚ କରନ୍ତୁ:",
  },
  recordAgain: {
    "en": "Delete",
    "hi": "डिलीट",
    "or": "ଡିଲିଟ୍ କରନ୍ତୁ",
  },
  send: {
    "en": "Send",
    "hi": "भेजें",
    "or": "ପଠାନ୍ତୁ"
  }
};

export const deleteAudio = {
  title: {
    "en": "Delete this recording?",
    "hi": "रिकॉर्डिंग डिलीट करें?",
    "or": "ଏହି ରେକର୍ଡିଂ ଡିଲିଟ୍ କରିବେ କି?",
    "mr": "हे रेकॉर्डिंग डिलीट करायचे?"
  },
  yes: {
    "en": "Yes, delete it",
    "hi": "हाँ , डिलीट करें",
    "or": "ହଁ, ଏହାକୁ ଡିଲିଟ୍ କରନ୍ତୁ",
    "mr": "हो, डिलीट करा"
  },
  no: {
    "en": "No, go back to editing",
    "hi": "नहीं, एडिट पर लौटें",
    "or": "ନା, ଏଡିଟିଂକୁ ଫେରି ଯାଆନ୍ତୁ",
    "mr": "नाही, पुन्हा एडिट करा"
  }
};
